import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { useTranslation } from '../useTranslation';

const EventDetails = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    const fetchEvent = async () => {
      const { data, error } = await supabase
        .from("events")
        .select("*")
        .eq("id", id)
        .single();

      if (!error) setEvent(data);
      else console.error("Erreur chargement détail :", error.message);
    };

    fetchEvent();
  }, [id]);

  if (!event) return <p className="text-center my-5">{t('loading')}</p>;

  return (
    <>
      <section id="about" className="about">
        <div className="container" data-aos="fade-up">
          <div className="row">
            <div
              className="col-lg-6 order-1 order-lg-2"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="about-img">
                <img
                  src={event.image_url}
                  alt={event.title}
                  className="img-fluid rounded"
                />
              </div>
            </div>

            <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
              <h3>{event.title}</h3>
              <p className="fst-italic">
                {new Date(event.date).toLocaleString()} – {event.location}
              </p>
              <ul>
  <li><i className="bi bi-check-circle"></i> {t('eventFeature1')}</li>
  <li><i className="bi bi-check-circle"></i> {t('eventFeature2')}</li>
  <li><i className="bi bi-check-circle"></i> {t('eventFeature3', { event })}</li>
</ul>
              <p>{event.description}</p>
            </div>
          </div>
        </div>
      </section>

      <section id="why-us" className="why-us">
        <div className="container" data-aos="fade-up">
  <div className="section-title">
    <h2>{t('whyAttendTitle')}</h2>
    <p>{t('whyAttendSubtitle')}</p>
  </div>
  <div className="row">
    <div className="col-lg-4">
      <div className="box" data-aos="zoom-in" data-aos-delay="100">
        <span>01</span>
        <h4>{t('reason1Title')}</h4>
        <p>{t('reason1Desc')}</p>
      </div>
    </div>
    <div className="col-lg-4 mt-4 mt-lg-0">
      <div className="box" data-aos="zoom-in" data-aos-delay="200">
        <span>02</span>
        <h4>{t('reason2Title')}</h4>
        <p>{t('reason2Desc')}</p>
      </div>
    </div>
    <div className="col-lg-4 mt-4 mt-lg-0">
      <div className="box" data-aos="zoom-in" data-aos-delay="300">
        <span>03</span>
        <h4>{t('reason3Title')}</h4>
        <p>{t('reason3Desc')}</p>
      </div>
    </div>
  </div>
</div>
      </section>
    </>
  );
};

export default EventDetails;
